// extracted by mini-css-extract-plugin
export default {"section":"CarBasicInfo_section__gawSW","header":"CarBasicInfo_header__WzhtY","grid":"CarBasicInfo_grid__glCEL"};